import { apiGet, apiPost } from './index'

const getSimulators = params => apiGet(`/api/simulator/${params.simulatorId}`, params)

const getRemindBool = params => apiGet(`/api/sys/function/remind/${params.userId}/${params.readType}`, params)

const postRemind = params => apiPost(`/api/sys/function/remind`, params)
const postSimulatorSign = params => apiPost(`/api/simulator/sign`, params)
const getRemindObj = params => apiGet(`/api/sys/function/remind`, params)
const postRemindObj = params => apiPost(`/api/sys/function/remind/update`, params)
const getKdSimulatorCaseList = params => apiGet('/api/kdSimulator/case', params)

export { getSimulators, getRemindBool, postRemind, postSimulatorSign, getRemindObj, postRemindObj, getKdSimulatorCaseList }



// WEBPACK FOOTER //
// ./src/api/simulator.js